module.exports = __webpack_public_path__ + "assets/img/ios.4dd29bf0.svg";